module.exports = __webpack_public_path__ + "img/ff535de.jpg";